import { render } from "./HeaderApp.vue?vue&type=template&id=0febf348&scoped=true"
import script from "./HeaderApp.vue?vue&type=script&lang=js"
export * from "./HeaderApp.vue?vue&type=script&lang=js"

import "./HeaderApp.vue?vue&type=style&index=0&id=0febf348&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0febf348"]])

export default __exports__